// extracted by mini-css-extract-plugin
export var button = "_cp-4";
export var hasDarkBackground = "_cp-7";
export var hasLightBackground = "_cp-6";
export var iconWrapper = "_cp-0";
export var large = "_cp-2";
export var medium = "_cp-1";
export var small = "_cp-5";
export var xsmall = "_cp-3";